import useUnidadesContasPaginado from "features/cobranca/hooks/useUnidadesContasPaginado";
import useTotalDashboard from "features/unidades/dashboard/useTotalDashboard";
import CollapsibleListCard from "../CollapsibleListCard";
import useCobrancaCardColumns from "./../../hooks/useCobrancaCardColumns";
import ModalFormConta from "components/Features/Financeiro/FormConta/ModalFormConta";
import { OperacaoEnum, TipoEntidadeEnum } from "core/resources/enums/conta";
import { useState, useEffect } from "react";
import ModalFormPagarConta from "components/Features/Financeiro/FormConta/ModalFormPagarConta";
import { ModalContentConta } from "components/ModalContentConta";
import { useInvalidateQuery } from "infra/packages/react-query";
import { CobrancaContaItem } from "core/features/cobranca/typings";

function CardBoletos({ unidadeId }: { unidadeId: string }) {
  const { data, isLoading, refetch } = useTotalDashboard(
    `/v1/unidades/dashboard/${unidadeId}/total-boletos`
  );

  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();
  const [pagarContaId, setPagarContaId] = useState<string | undefined>();
  const [editId, setEditId] = useState<string | undefined>();
  const [modalCadastroVisible, setModalCadastroVisible] = useState(false);
  const [detalheId, setDetalheId] = useState<string | undefined>();

  useEffect(() => {
    if (editId) {
      setModalCadastroVisible(true);
    }
  }, [editId]);
  return (
    <CollapsibleListCard
      unidadeId={unidadeId}
      setDetalheId={setDetalheId}
      isLoading={isLoading}
      value={data?.total ?? 0}
      singularTitleText="histórico de boleto"
      getDataHook={useUnidadesContasPaginado}
      useColumnsHook={useCobrancaCardColumns}
      newEntryButtonText="Nova cobrança"
      NewEntryModal={({ isVisible, onClose, refetch }) => (
        <ModalFormConta
          operacao={OperacaoEnum.Receita}
          isOpen={isVisible}
          onClose={onClose}
          defaultData={{
            tipoEntidadeId: TipoEntidadeEnum.Condomino,
            unidadeId,
          }}
          onSuccess={() => {
            refetch?.();
          }}
        />
      )}
      onRow={(v: CobrancaContaItem) => ({
        onClick: () => setDetalheId!(v.id),
        style: {
          cursor: "pointer",
        },
      })}
      children={
        <>
          {modalCadastroVisible ? (
            <ModalFormConta
              operacao={OperacaoEnum.Receita}
              id={editId}
              isOpen={modalCadastroVisible}
              onClose={() => {
                setModalCadastroVisible(false);
                setEditId(undefined);
              }}
              onSuccess={() => {
                doInvalidateQueryWithStringKey(`/v1/cobranca/${unidadeId}`);
                setEditId(undefined);
                refetch();
                setModalCadastroVisible(false);
              }}
              onSuccessImmediatelyAfterSave={false}
            />
          ) : null}
          {pagarContaId ? (
            <ModalFormPagarConta
              operacao={OperacaoEnum.Receita}
              contaId={pagarContaId}
              isOpen={!!pagarContaId}
              onClose={() => setPagarContaId(undefined)}
              onSaved={() => {
                doInvalidateQueryWithStringKey(`/v1/cobranca/${unidadeId}`);
                refetch();
                setPagarContaId(undefined);
              }}
            />
          ) : null}
          {detalheId ? (
            <ModalContentConta
              isOpenModal={!!detalheId}
              onClose={() => setDetalheId(undefined)}
              contaId={detalheId}
              onEdit={setEditId}
              onLiquidar={setPagarContaId}
              operacao={OperacaoEnum.Receita}
              refetch={() => refetch()}
            />
          ) : null}{" "}
        </>
      }
    />
  );
}

export default CardBoletos;
